function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9271",
  d: "M9.5 5.8c-1.2 1.5-1.9 3.3-1.9 5.4 0 4.7 8.5 18.4 8.5 18.4s3.6-5.8 6.1-11.2L9.5 5.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff744a",
  d: "M9.5 5.8c-1.2 1.5-1.9 3.3-1.9 5.4 0 4.7 8.5 18.4 8.5 18.4s3.6-5.8 6.1-11.2L9.5 5.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9271",
  d: "M24.5 11.2c0-4.7-3.8-8.5-8.5-8.5-2.6 0-5 1.2-6.5 3.1l12.6 12.6c1.3-2.8 2.4-5.6 2.4-7.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fa3a00",
  d: "M19.6 11.5c0 2-1.6 3.6-3.6 3.6s-3.6-1.6-3.6-3.6S14 7.9 16 7.9s3.6 1.6 3.6 3.6"
}));